import { InspectionStatuses, OffsiteFacility } from './../shared/models/Inspection';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { InspectionService } from "../shared/services/inspection.service";
import { Inspection, InspectionFee, InspectionTypes as ITPS } from "../shared/models/Inspection";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { environment } from "../../../environments/environment";
import { FormGroup } from "@angular/forms";
import { FormlyFormOptions } from "@ngx-formly/core";
import { ErisFormComponent } from "eris-forms";
import { AlertService } from "../../shared/services/alert.service";
import * as Constants from "../../models/Constants";
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: "app-renew-abroad-cgmp-inspection",
  templateUrl: "./renew-abroad-cgmp-inspection.component.html",
  styleUrls: ["./renew-abroad-cgmp-inspection.component.css"],
})
export class RenewAbroadCgmpInspectionComponent implements OnInit, AfterViewInit {
  
  @ViewChild(ErisFormComponent) erisFormComponent!: ErisFormComponent;
  public productionSubTypeModule: any;
  public currentInspectionType: string;
  public currentInspectionName: string;
  public previousInspectionId: any;
  public form = new FormGroup({});
  public options: FormlyFormOptions = {};
  public approvalMethod: string = Constants.CATEGORY_B;
  public isEditMode = false;
  public inspection: Inspection;
  public inspectionListLink = "";
  public inspectionFees :InspectionFee[] = [];
  public sraDetail : string = "";
  public categoryId : number = 0;
  public agencyId : number = 0;
  public applicantTypeId : number = 0;
  public isFIREditing : boolean = false;

  constructor(private inspectionService: InspectionService, private spinner: NgxSpinnerService, private router: Router,
    private activatedRoute: ActivatedRoute, private cdr: ChangeDetectorRef, private alertService: AlertService,
    private errorHandlerService: ErrorHandlerService) {
    this.currentInspectionType = this.activatedRoute.snapshot.params[
      "inspectionTypeCode"
    ];

    this.activatedRoute.params.subscribe((params) => {
      const inspectionTypeCode = params["inspectionTypeCode"];
      console.log("inspectionTypeCode : ", inspectionTypeCode);
      this.currentInspectionName = ITPS.codeToName(inspectionTypeCode);
      this.currentInspectionType = inspectionTypeCode;
      this.inspectionListLink = this.currentInspectionType == 'ACIR' ? "/inspections/abroadCGMP/list/ABROADCGMP" :
        "/inspections/abroadCGMP/list/ABROADCGMPWAIVER";
    });
  }

  ngOnInit(): void {
    this.inspectionService.getInspectionFees().subscribe(resp => {
      this.inspectionFees = resp;
      let sraInspFee = this.inspectionFees.find(f => f.isSra == true);
      if(sraInspFee){
        this.sraDetail = sraInspFee.description;
      }
    });
  }

  ngAfterViewInit() : void{
    const id = this.activatedRoute.snapshot.params['id'];
    if(id){
      this.isEditMode = true;
      if(this.currentInspectionType == ITPS.ABROAD_CGMP_RENEWAL_INSPECTION){
        this.fetchDataTobeFiled(id);
      } else {
        this.fetchDataTobeFiledForWaiver(id);
      }  
    }
  }

  onSubmit(event) {
    this.spinner.show();
    let link = "Renewal";
    let path = "ABROADCGMP";
    if (this.currentInspectionType == "ACIWR") {
      link = "Waiver/Renewal";
      path = "ABROADCGMPWAIVER"
    }
    
    if(this.isFIREditing) {
      this.inspectionService.submitFurtherInformation(this.inspection.id, event.fileAttachment).subscribe(res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success("Your Application was submitted successfully");
          this.router.navigate(["inspections/abroadCGMP/list/"+path]);
        } else {
          this.alertService.error("Unable to submit your Application, please try again!");
        }
      }, error => {
        console.log(error);
        this.spinner.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(error));
      });    
    } else {
      event.productionInformation["productDetails"] = event.productionInformation.productDetailData?.productDetails;
      event.previousInspectionId = this.previousInspectionId;
      let appliedFees = this.inspectionService.getAppliedFees(event, this.currentInspectionType, this.inspectionFees);
      const address = event.paymentInformation.siteAddress;
      event.paymentInformation = {
        ...event.paymentInformation,
        appliedFees: appliedFees 
      };
      for (var element of event.paymentInformation.appliedFees) {
        element.siteAddress = address;
      }     

      if(!this.isEditMode){
        this.inspectionService.postAbroadApplicationForm(event, link).subscribe(res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success("Your Application was submitted successfully");
            this.router.navigate(["inspections/abroadCGMP/list/"+path]);
          } else {
            this.alertService.error("Unable to submit your Application, please try again!");
          }
        }, error => {
          console.log(error)
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(error));
        });
      } else {
        event.inspectionId = this.inspection.id;
        this.inspectionService.editAbroadApplicationForm(event, link).subscribe(res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success("Your Application was edited successfully");
            this.router.navigate(["inspections/abroadCGMP/list/"+path]);
          } else {
            this.alertService.error("Unable to edit your Application, please try again!");
          }
        }, error => {
          console.log(error)
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(error));
        });
      }
        
    }

  }

  fetchDataTobeFiled(inspectionId) {
    this.spinner.show();
    this.inspectionService.getAbroadInspection(inspectionId).subscribe((data) => {
        this.inspection = data;
        this.isFIREditing = [InspectionStatuses.FIR_REQUESTED_BEFORE_INSPECTION, 
          InspectionStatuses.FIR_REQUESTED_AFTER_INSPECTION].includes(data.status.inspectionStatusCode);
        var localAgent = {
          approvedLocalAgent : null,
          localAgentName: data.inspectionAbroadFacility[0].abroadFacility.localAgentName,
          phone: data.inspectionAbroadFacility[0].abroadFacility.localAgentPhone,
          email: data.inspectionAbroadFacility[0].abroadFacility.localAgentEmail,
        };

        if(this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent){
          localAgent.approvedLocalAgent = { id : this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.id, 
                                            name: this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.name,
                                            email: this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.email,
                                            phone: this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.phone};
        } else {
          localAgent.approvedLocalAgent = { id : 0, name : 'Other'};
        }

        var manufacturer = {
          manufacturerName: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.name,
          country: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.country,
          site: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.siteAddress,
          email:data.inspectionAbroadFacility[0].abroadFacility.manufacturer.email,
          website: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.website,

          qualityAssuranceName: data.inspectionAbroadFacility[0].abroadFacility.qualityAssuranceName,
          qualityAssurancePhone:data.inspectionAbroadFacility[0].abroadFacility.qualityAssurancePhone,
          qualityAssuranceEmail:data.inspectionAbroadFacility[0].abroadFacility.qualityAssuranceEmail,
  
          qualityControlName: data.inspectionAbroadFacility[0].abroadFacility.qualityControlName,
          qualityControlPhone:data.inspectionAbroadFacility[0].abroadFacility.qualityControlPhone,
          qualityControlEmail:data.inspectionAbroadFacility[0].abroadFacility.qualityControlEmail,
  
          productManagerName: data.inspectionAbroadFacility[0].abroadFacility.productManagerName,
          productManagerPhone:data.inspectionAbroadFacility[0].abroadFacility.productManagerPhone,
          productManagerEmail:data.inspectionAbroadFacility[0].abroadFacility.productManagerEmail,
  
          internationalMarketingName: data.inspectionAbroadFacility[0].abroadFacility.internationalMarketingName,
          internationalMarketingPhone:data.inspectionAbroadFacility[0].abroadFacility.internationalMarketingPhone,
          internationalMarketingEmail:data.inspectionAbroadFacility[0].abroadFacility.internationalMarketingEmail,
  
          regularityAffairName: data.inspectionAbroadFacility[0].abroadFacility.regularityAffairName,
          regularityAffairPhone:data.inspectionAbroadFacility[0].abroadFacility.regularityAffairPhone,
          regularityAffairEmail:data.inspectionAbroadFacility[0].abroadFacility.regularityAffairEmail,
  
          ownerName: data.inspectionAbroadFacility[0].abroadFacility.ownerName,
          ownerPhone:data.inspectionAbroadFacility[0].abroadFacility.ownerPhone,
          ownerEmail:data.inspectionAbroadFacility[0].abroadFacility.ownerEmail,
        };

        this.approvalMethod = data.productionInfo.approvalMethod?.name;
        let newProductionInformation = {
          productDetailData: {
            productDetails: data.productionInfo.productDetails?.filter(p => p.productionLine?.isActive == true)
          }
        };
        
        if(!this.isEditMode){
          this.erisFormComponent.model = {
            facilties: this.erisFormComponent.form.value.facilties,
            localAgentInformation: localAgent,
            productionInformation: newProductionInformation,
            manufacturer: manufacturer,
            fileAttachment: this.erisFormComponent.form.value.fileAttachment
          };
        } else {
          this.erisFormComponent.model = {
            facilties: { facility : {
              id: data.inspectionAbroadFacility[0].abroadFacilityID, 
              name: manufacturer.manufacturerName
            } },
            localAgentInformation: localAgent,
            manufacturer: manufacturer,
            productionInformation: newProductionInformation,
            paymentInformation: {},
            fileAttachment: {documents: data.documents}
          };

          this.categoryId = data.productionInfo.approvalMethod?.id;
          this.agencyId = data.productionInfo.agency?.id;
          this.applicantTypeId = data.inspectionAbroadFacility[0].applicantTypeID;
          
          if(this.inspection.appliedFees && this.inspection.appliedFees.length > 0){ 
            this.erisFormComponent.model.paymentInformation['WHRF'] = this.inspection.appliedFees.findIndex(f => f.code == 'WHRF') > -1;
            this.erisFormComponent.model.paymentInformation['PFPQ'] = this.inspection.appliedFees.findIndex(f => f.code == 'PFPQ') > -1;
            this.erisFormComponent.model.paymentInformation['QCDL'] = this.inspection.appliedFees.findIndex(f => f.code == 'QCDL') > -1;
            let paymentAddrFee = this.inspection.appliedFees.find(f => f.isSra == false && f.hasMultipleFacility == false && f.code != 'MTTP');
            if(paymentAddrFee){
              this.erisFormComponent.model.paymentInformation['inspectionFee'] = { ...paymentAddrFee, name: paymentAddrFee.type };
            }
            var siteAddress = this.inspection.appliedFees.find(a => a.siteAddress != null)?.siteAddress;
            this.erisFormComponent.model.paymentInformation['siteAddress'] = siteAddress;
            }
        }

        this.cdr.detectChanges();
        this.spinner.hide();
      });
  }

  fetchDataTobeFiledForWaiver(inspectionId) {
    this.spinner.show();
    this.inspectionService.getAbroadInspection(inspectionId).subscribe((data) => {
        this.inspection = data;
        this.isFIREditing = [InspectionStatuses.FIR_REQUESTED_BEFORE_INSPECTION, 
          InspectionStatuses.FIR_REQUESTED_AFTER_INSPECTION].includes(data.status.inspectionStatusCode);
        this.categoryId = data.productionInfo.approvalMethodID;
        this.agencyId = data.productionInfo.agencyID;
        var localAgent = {
          approvedLocalAgent : null,
          localAgentName: data.inspectionAbroadFacility[0].abroadFacility.localAgentName,
          phone: data.inspectionAbroadFacility[0].abroadFacility.localAgentPhone,
          email: data.inspectionAbroadFacility[0].abroadFacility.localAgentEmail,
        };

        if(this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent){
          localAgent.approvedLocalAgent = { id : this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.id, 
                                            name: this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.name,
                                            email: this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.email,
                                            phone: this.inspection.inspectionAbroadFacility[0].abroadFacility.approvedAgent.phone};
        } else {
          localAgent.approvedLocalAgent = { id : 0, name : 'Other'};
        }

        var manufacturer = {
          manufacturerName: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.name,
          country: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.country,
          site: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.siteAddress,
          email: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.email,
          website: data.inspectionAbroadFacility[0].abroadFacility.manufacturer.website,

          qualityAssuranceName: data.inspectionAbroadFacility[0].abroadFacility.qualityAssuranceName,
          qualityAssurancePhone:data.inspectionAbroadFacility[0].abroadFacility.qualityAssurancePhone,
          qualityAssuranceEmail:data.inspectionAbroadFacility[0].abroadFacility.qualityAssuranceEmail,
  
          qualityControlName: data.inspectionAbroadFacility[0].abroadFacility.qualityControlName,
          qualityControlPhone:data.inspectionAbroadFacility[0].abroadFacility.qualityControlPhone,
          qualityControlEmail:data.inspectionAbroadFacility[0].abroadFacility.qualityControlEmail,
  
          productManagerName: data.inspectionAbroadFacility[0].abroadFacility.productManagerName,
          productManagerPhone:data.inspectionAbroadFacility[0].abroadFacility.productManagerPhone,
          productManagerEmail:data.inspectionAbroadFacility[0].abroadFacility.productManagerEmail,
  
          internationalMarketingName: data.inspectionAbroadFacility[0].abroadFacility.internationalMarketingName,
          internationalMarketingPhone:data.inspectionAbroadFacility[0].abroadFacility.internationalMarketingPhone,
          internationalMarketingEmail:data.inspectionAbroadFacility[0].abroadFacility.internationalMarketingEmail,
  
          regularityAffairName: data.inspectionAbroadFacility[0].abroadFacility.regularityAffairName,
          regularityAffairPhone:data.inspectionAbroadFacility[0].abroadFacility.regularityAffairPhone,
          regularityAffairEmail:data.inspectionAbroadFacility[0].abroadFacility.regularityAffairEmail,
  
          ownerName: data.inspectionAbroadFacility[0].abroadFacility.ownerName,
          ownerPhone:data.inspectionAbroadFacility[0].abroadFacility.ownerPhone,
          ownerEmail:data.inspectionAbroadFacility[0].abroadFacility.ownerEmail,
        }; 

        this.approvalMethod = data.productionInfo.approvalMethod?.name;
        var productionInformation = {};
        if (this.approvalMethod == Constants.CATEGORY_A) {
          productionInformation = {
            category: data.productionInfo.approvalMethod,
            agency: data.productionInfo.agency,
            brandName: data.productionInfo.productBrandName,
            dosageForms: data.productionInfo.prodInfoDosageForms?.map(p => p.dosageForm),
            genericName: data.productionInfo.productGenericName,
          };
        } else {
          productionInformation = {
            category: data.productionInfo.approvalMethod,
            country: data.productionInfo.country,
            productDetailData: {
              productDetails: data.productionInfo.productDetails?.filter(p => p.productionLine?.isActive == true)
            }
          };
        }

        if(!this.isEditMode){
          this.erisFormComponent.model = {
            facilties: this.erisFormComponent.form.value.facilties,
            localAgentInformation: localAgent,
            manufacturer: manufacturer,
            productionInformation: productionInformation,     
            fileAttachment: this.erisFormComponent.form.value.fileAttachment
          };
        } else {
          this.erisFormComponent.model = {
            facilties: { facility : {
              id: data.inspectionAbroadFacility[0].abroadFacilityID, 
              name: manufacturer.manufacturerName
            } },
            localAgentInformation: localAgent,
            manufacturer: manufacturer,
            productionInformation: productionInformation,
            fileAttachment: {documents: data.documents}
          };
          this.applicantTypeId = data.inspectionAbroadFacility[0].applicantTypeID;
        }

        this.cdr.detectChanges()
        this.spinner.hide();
      });
  }

  waiverFields = [
      {
        type: "steps",
        fieldGroup: [
          {
            key: "facilties",
            fieldGroupClassName: "row",
            templateOptions: { title: "Facilities" },
            fieldGroup: [
              {
                key: "facility",
                type: "lookup",
                className: "col-md-6",
                templateOptions: {
                  label: "Facilities",
                  required: true,
                  multiple: false,
                  prefetch: true,
                  searchable: false,
                  minLengthTerm: 0,
  
                  responseFn: (res) => {
                    if(res.inspectionID){
                      this.previousInspectionId = res.inspectionID;
                      this.fetchDataTobeFiledForWaiver(this.previousInspectionId);
                    }                
                    return {
                      name: res.name,
                      id: res.id,
                      inspectionID: res.inspectionID,
                      isLegacyData: res.isLegacyData,
                      inspectionStatusCode: res.inspectionStatusCode,
                    };
                  },
                  list: {
                    method: "get",
                    url: (term) =>
                      `${environment.baseUrl}/Inspection/AbroadCGMPInspection/Waiver/Renewal/GetAbroadFacilities`,
                    responseFn: (res) => {
                      let index = 0;
                      res.forEach((element) => {
                        res[index].name = res[index].manufacturerName;
                        ++index;
                      });
                      return res;
                    },
                  },
                },
                validators: {
                  validation: ["legacy"],
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return false;
                },
                hooks: {
                  onInit: (field: FormlyFieldConfig) => {
                    console.log("inside hook");
                    field.form.get("facility").valueChanges.subscribe((data) => {
                      this.valueChanged(field);
                    });
                  },
                },
                expressionProperties: {
                  "className": () => {
                    return this.isEditMode ? "col-md-6 disabled" : "col-md-6";
                  },
                }
              },
              {
                type: 'edit-anchor',
                key: 'editApplication',
                className: "col-md-6",
                templateOptions: {
                  inspectionType: 'NACIW'
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                },
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "localAgentInformation",
            fieldGroupClassName: "row",
            templateOptions: { title: "Local Agent Information" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    key: "approvedLocalAgent",
                    type: "lookup",
                    className: "col-md-6",
                    templateOptions: {
                      label: 'Local Agent',
                      multiple: false,
                      prefetch: false,
                      searchable: true,
                      minLengthTerm: 3,
                      required: true,
                      responseFn: (res) => ({name: res?.name, id: res?.id, phone: res?.phone, email: res?.email}),
                      list: {
                        method: 'post',
                        url: (term) => `${environment.baseUrl}/LocalAgent/Search`,
                        data: (term) => ({query: term, pageNumber: 0, pageSize: 50}),
                        responseFn: res => {
                          if(res?.data) {
                            res.data.push({name: 'Other', id : 0});
                            return res.data;
                          } else {
                            return [{name: 'Other', id : 0}]
                          }
                        }
                      },
                    },
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br>",
                      },
                    ],
                  },
                  {
                    key: "approvedAgentPhone",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Phone",
                      type: "text",
                      disabled: true,
                      placeholder: '',
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                        return false;
                      }
                      return true;
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                        return model.approvedLocalAgent?.phone;
                      },
                    },
                  },
                  {
                    key: "approvedAgentEmail",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Email",
                      type: "text",
                      disabled: true,
                      placeholder: '',
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                        return false;
                      }
                      return true;
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                        return model.approvedLocalAgent?.email;
                      },
                    },
                  },
                  {
                    key: "localAgentName",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Name of Local Agent",
                      type: "text",
                      required: true,
                    },
                    validators: {
                      validation: ["normal-text"],
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                        return false;
                      }
                      return true;
                    },
                  },
                  {
                    key: "phone",
                    type: "international-phone",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Phone",
                      required: true,
                      editing: false,
                    },
                    expressionProperties: {
                      "templateOptions.editing": () => {
                        return this.isEditMode;
                      },
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                        return false;
                      }
                      return true;
                    },
                  },
                  {
                    key: "email",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Email Address",
                      required: true,
                      type: "email",
                    },
                    validators: {
                      validation: ["email"],
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                        return false;
                      }
                      return true;
                    },
                  },
                ],
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "manufacturer",
            templateOptions: { title: "Manufacturer" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "manufacturerName",
                        type: "input",
                        className: "col-md-6 disabled",
                        templateOptions: {
                          type: "text",
                          label: "Manufacturer Name",
                          required: true,
                          disabled: true
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "country",
                        type: "lookup",
                        className: "col-md-6 disabled",
                        templateOptions: {
                          label: "Country",
                          required: true,
                          disabled: true,
                          multiple: false,
                          prefetch: true,
                          searchable: false,
                          minLengthTerm: 0,
                          responseFn: (res) => ({
                            name: res.name,
                            id: res.id,
                          }),
                          list: {
                            method: "get",
                            url: (term) => `${environment.baseUrl}/Country`,
                            responseFn: (res) => res,
                          },
                        },
                      },
                      {
                        key: "site",
                        type: "input",
                        className: "col-md-6 disabled",
                        templateOptions: {
                          type: "text",
                          label: "Site Address",
                          required: true,
                          disabled: true,
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "email",
                        type: "input",
                        className: "col-md-6 disabled",
                        templateOptions: {
                          label: "Email Address",
                          required: true,
                          disabled: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                      {
                        key: "website",
                        type: "input",
                        className: "col-md-6 disabled",
                        templateOptions: {
                          label: "Website",
                          required: true,
                          disabled: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                    ],
                  },

                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Key Persons of the Manufacturer</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Quality Assurance</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "qualityAssuranceName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "qualityAssurancePhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "qualityAssuranceEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Quality Control</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "qualityControlName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "qualityControlPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "qualityControlEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Product Manager</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "productManagerName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "productManagerPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "productManagerEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>International Marketing</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "internationalMarketingName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "internationalMarketingPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "internationalMarketingEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Regularity Affair</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "regularityAffairName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "regularityAffairPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "regularityAffairEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Owner</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "ownerName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: false,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "ownerPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: false,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "ownerEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: false,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                ],
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "productionInformation",
            templateOptions: { title: "Production Information" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    key: "category",
                    type: "lookup",
                    className: "col-md-6",
                    templateOptions: {
                      label: "SRA Category",
                      required: true,
                      multiple: false,
                      prefetch: true,
                      searchable: false,
                      minLengthTerm: 0,
                      responseFn: (res) => {
                        this.categoryId = res.id; 
                        return ({
                          name: res.name,
                          id: res.id,
                        });
                      },
                      list: {
                        method: "get",
                        url: (term) => `${environment.baseUrl}/ApprovalMethod`,
                        responseFn: (res) => res,
                      },
                    },
                  },
                  {
                    key: "agency",
                    type: "lookup",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Agency",
                      required: true,
                      multiple: false,
                      prefetch: true,
                      searchable: false,
                      minLengthTerm: 0,
                      responseFn: (res) => { 
                        this.agencyId = res.id; 
                        return ({
                        name: res.name,
                        id: res.id,
                      })
                      },
                      list: {
                        method: "get",
                        url: (term) => `${environment.baseUrl}/Agency`,
                        responseFn: (res) => res,
                      },
                    },
                    hideExpression: (
                      model: any,
                      formState: any,
                      field: FormlyFieldConfig
                    ) => {
                      var id = field.form.get("category").value;
                      if (id != null) {
                        if (id["id"] == 1) {
                          return false;
                        }
                        return true;
                      }
                      return true;
                    },
                  },
                  {
                    key: "brandName",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Brand Name",
                      type: "text",
                      required: true,
                    },
                    hideExpression: (
                      model: any,
                      formState: any,
                      field: FormlyFieldConfig
                    ) => {
                      var id = field.form.get("category").value;
                      if (id != null) {
                        if (id["id"] == 1) {
                          return false;
                        }
                        return true;
                      }
                      return true;
                    },
                  },
                  {
                    key: "genericName",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Generic Name",
                      type: "text",
                      required: true,
                    },
                    hideExpression: (
                      model: any,
                      formState: any,
                      field: FormlyFieldConfig
                    ) => {
                      var id = field.form.get("category").value;
                      if (id != null) {
                        if (id["id"] == 1) {
                          return false;
                        }
                        return true;
                      }
                      return true;
                    },
                  },
                  {
                    key: "dosageForms",
                    type: "lookup",
                    className: "col-md-6",
                    templateOptions: {
                      label: 'Dosage Form',
                      multiple: true,
                      prefetch: false,
                      searchable: true,
                      minLengthTerm: 3,
                      required: true,
                      responseFn: (res) => {
                        return res;
                      },
                      list: {
                        method: 'post',
                        url: (term) => `${environment.baseUrl}/DosageForm/Search`,
                        data: (term) => ({query: term, pageNumber: 0, pageSize: 50}),
                        responseFn: res => res?.data
                      },
                      },
                    hideExpression: (
                      model: any,
                      formState: any,
                      field: FormlyFieldConfig
                    ) => {
                      var id = field.form.get("category").value;
                      if (id != null) {
                        if (id["id"] == 1) {
                          return false;
                        }
                        return true;
                      }
                      return true;
                    },
                  },
                  {
                    key: "country",
                    type: "lookup",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Country",
                      required: true,
                      multiple: false,
                      prefetch: true,
                      searchable: false,
                      minLengthTerm: 0,
                      responseFn: (res) => ({
                        name: res.name,
                        id: res.id,
                      }),
                      list: {
                        method: "get",
                        url: (term) => `${environment.baseUrl}/Country/bycategory/${this.categoryId}`,
                        responseFn: (res) => res,
                      },
                    },
                    hideExpression: (
                      model: any,
                      formState: any,
                      field: FormlyFieldConfig
                    ) => {
                      var id = field.form.get("category").value;
                      if (id != null) {
                        if (id["id"] == 2 || id["id"] == 3) {
                          return false;
                        }
                        return true;
                      }
                      return true;
                    },
                  },
                  {
                    key: "productDetailData",
                    type: "gmp-product-detail",
                    className: "col-md-12",
                    templateOptions: {
                      isDisabled: false,
                      editing: false,
                      dependsOnField: "productionInformation.category",
                      isDataFilled: true
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      let cat = field.form.get("category").value;
                      if (cat != null) {
                        if (cat["id"] == 2 || cat["id"] == 3) {
                          return false;
                        }
                        return true;
                      }
                      return true;
                    },
                    expressionProperties: {
                      "templateOptions.editing": () => {
                        return this.isEditMode;
                      },
                    }
                  },            
                ],
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "paymentInformation",
            templateOptions: { title: "Payment Information" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  
                  {
                    className: "col-md-7",
                    type: 'textarea',
                    templateOptions: {
                      label: "Detail",
                      placeholder: "",
                      rows: 3,
                      disabled: true
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': () => {
                        return this.sraDetail;
                      },
                    },
                  },
                  {
                    type: "input",
                    className: "col-md-7",
                    templateOptions: {
                      label: 'Total Fee',
                      placeholder: '0',
                      dependsOnField: "productionInformation.productDetailData",
                      disabled: true
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                        var appliedFees = [];
                        let totalFee = 0;
                        if(this.inspectionFees.length > 0){
                          appliedFees.push(this.inspectionFees.find(f => f.isSra == true));   
                          totalFee += appliedFees[0].amount;          
                        } 
                        
                        let prodDetails = field.form.parent?.value?.productionInformation?.productDetailData?.productDetails;
                        // multiple offsite facility payment
                        if(prodDetails && prodDetails.length > 0) {
                          const { uniqueOffsiteFacilitiesByNameAndAddressCount } = this.inspectionService.getOffsiteFacilitiesInfo(prodDetails)  

                          if(uniqueOffsiteFacilitiesByNameAndAddressCount > 0) {
                            appliedFees.push(this.inspectionFees.find(f => f.code == "MOF"));
                            totalFee += (uniqueOffsiteFacilitiesByNameAndAddressCount * this.inspectionFees.find(f => f.code == "MOF").amount);
                          }                        
                        }

                        return totalFee + " (in USD)"; 
                      },
                    },
                  },   
                  {
                    fieldGroupClassName: "col-md-7",
                    fieldGroup: [
                      {
                        template: "",
                       
                        expressionProperties: {
                          'template': () => {
                            let multipleOffsiteFacilityFee = this.inspectionFees.find(f => f.code == 'MOF');
                            if(multipleOffsiteFacilityFee){
                              let template = `<span><span class='text-danger'>*</span>when offsite facilities are added, 
                                each offsite facility added costs ${multipleOffsiteFacilityFee.amount} (in USD) </span>`
                              return template;
                            }
                          },
                        },
                      },
                    ],
                  },           
                ]
              }
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "fileAttachment",
            templateOptions: {
              title: "File Attachment",
              icon: "fa fa-info-circle",
            },
            fieldGroup: [
              {
                key: "documents",
                type: "upload-list",

                templateOptions: {
                  label: "Applicant Name",
                  required: true,
                  items: [],
                  dependsOnField: "productionInformation",
                  dataSourceFn: (submoduleCode) => {
                    return {
                      url: `/DocumentRef/GMP/${submoduleCode}`,
                    };
                  },
                  extraData: {
                    urlParameter: "",
                    originalFileName: "-",
                    editing: false,
                    categoryTypeID: "",
                    AgencyTypeID: "",
                    ApplicantTypeID: "",
                  },
                  responseFn: (res) => res,
                },
                expressionProperties: {
                  "templateOptions.extraData.urlParameter": (
                    model,
                    formState,
                    field
                  ) => {
                    return this.currentInspectionType;
                  },
                  "templateOptions.extraData.editing": () => {
                    return this.isEditMode;
                  },
                  "templateOptions.extraData.categoryTypeID": () => {
                    return this.categoryId;
                  },
                  "templateOptions.extraData.AgencyTypeID": () => {
                    return this.agencyId;
                  },
                  "templateOptions.extraData.ApplicantTypeID": () => {
                    return this.applicantTypeId;
                  },
                },
              },
            ],
          },
        ],
      },
  ];

  fields = [
      {
        type: "steps",
        fieldGroup: [
          {
            key: "facilties",
            fieldGroupClassName: "row",
            templateOptions: { title: "Facilities" },
            fieldGroup: [
              {
                key: "facility",
                type: "lookup",
                className: "col-md-6",
                templateOptions: {
                  label: "Facilities",
                  required: true,
                  multiple: false,
                  prefetch: true,
                  searchable: false,
                  minLengthTerm: 0,
  
                  responseFn: (res) => {
                    if(res.inspectionID){
                      this.previousInspectionId = res.inspectionID;
                      this.fetchDataTobeFiled(this.previousInspectionId);
                    }
                    return {
                      name: res.name,
                      id: res.id,
                      inspectionID: res.inspectionID,
                      isLegacyData: res.isLegacyData,
                      inspectionStatusCode: res.inspectionStatusCode,
                    };
                  },
                  list: {
                    method: "get",
                    url: (term) =>
                      `${environment.baseUrl}/Inspection/AbroadCGMPInspection/Renewal/GetAbroadFacilities`,
                    responseFn: (res) => {
                      let index = 0;
                      res.forEach((element) => {
                        console.log("element ");
                        res[index].name = res[index].manufacturerName;
                        ++index;
                      });
                      return res;
                    },
                  },
                },
                validators: {
                  validation: ["legacy"],
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return false;
                },
                hooks: {
                  onInit: (field: FormlyFieldConfig) => {
                    console.log("inside hook");
                    field.form.get("facility").valueChanges.subscribe((data) => {
                      this.valueChanged(field);
                    });
                  },
                },
                expressionProperties: {
                  "className": () => {
                    return this.isEditMode ? "col-md-6 disabled" : "col-md-6";
                  },
                }
              },
              {
                type: 'edit-anchor',
                key: 'editApplication',
                className: "col-md-6",
                templateOptions: {
                  inspectionType: 'NACI'
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                },
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "localAgentInformation",
            fieldGroupClassName: "row",
            templateOptions: { title: "Local Agent Information" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    key: "approvedLocalAgent",
                    type: "lookup",
                    className: "col-md-6",
                    templateOptions: {
                      label: 'Local Agent',
                      multiple: false,
                      prefetch: false,
                      searchable: true,
                      minLengthTerm: 3,
                      required: true,
                      responseFn: (res) => ({name: res?.name, id: res?.id, phone: res?.phone, email: res?.email}),
                      list: {
                        method: 'post',
                        url: (term) => `${environment.baseUrl}/LocalAgent/Search`,
                        data: (term) => ({query: term, pageNumber: 0, pageSize: 50}),
                        responseFn: res => {
                          if(res?.data) {
                            res.data.push({name: 'Other', id : 0});
                            return res.data;
                          } else {
                            return [{name: 'Other', id : 0}]
                          }
                        }
                      },
                    },
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br>",
                      },
                    ],
                  },
                  {
                    key: "approvedAgentPhone",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Phone",
                      type: "text",
                      disabled: true,
                      placeholder: '',
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                        return false;
                      }
                      return true;
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                        return model.approvedLocalAgent?.phone;
                      },
                    },
                  },
                  {
                    key: "approvedAgentEmail",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Email",
                      type: "text",
                      disabled: true,
                      placeholder: '',
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name != 'Other') {
                        return false;
                      }
                      return true;
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                        return model.approvedLocalAgent?.email;
                      },
                    },
                  },
                  {
                    key: "localAgentName",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Name of Local Agent",
                      type: "text",
                      required: true,
                    },
                    validators: {
                      validation: ["normal-text"],
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                        return false;
                      }
                      return true;
                    },
                  },
                  {
                    key: "phone",
                    type: "international-phone",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Phone",
                      required: true,
                      editing: false,
                    },
                    expressionProperties: {
                      "templateOptions.editing": () => {
                        return this.isEditMode;
                      },
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                        return false;
                      }
                      return true;
                    },
                  },
                  {
                    key: "email",
                    type: "input",
                    className: "col-md-6",
                    templateOptions: {
                      label: "Email Address",
                      required: true,
                      type: "email",
                    },
                    validators: {
                      validation: ["email"],
                    },
                    hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
                      var approvedLocalAgent = field.form.get("approvedLocalAgent").value;
                      if (approvedLocalAgent != null && approvedLocalAgent.name == 'Other') {
                        return false;
                      }
                      return true;
                    },
                  },
                ],
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "manufacturer",
            templateOptions: { title: "Manufacturer" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "manufacturerName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          type: "text",
                          label: "Manufacturer Name",
                          required: true,
                          disabled: true
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "country",
                        type: "lookup",
                        className: "col-md-6 disabled",
                        templateOptions: {
                          label: "Country",
                          required: true,
                          disabled: true,
                          multiple: false,
                          prefetch: true,
                          searchable: false,
                          minLengthTerm: 0,
                          responseFn: (res) => ({
                            name: res.name,
                            id: res.id,
                          }),
                          list: {
                            method: "get",
                            url: (term) => `${environment.baseUrl}/Country`,
                            responseFn: (res) => res,
                          },
                        },
                      },
                      {
                        key: "site",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          type: "text",
                          label: "Site Address",
                          required: true,
                          disabled: true
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "email",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email Address",
                          required: true,
                          disabled: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                      {
                        key: "website",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Website",
                          required: true,
                          disabled: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                    ],
                  },

                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Key Persons of the Manufacturer</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Quality Assurance</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "qualityAssuranceName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "qualityAssurancePhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "qualityAssuranceEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Quality Control</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "qualityControlName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "qualityControlPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "qualityControlEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Product Manager</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "productManagerName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "productManagerPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "productManagerEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>International Marketing</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "internationalMarketingName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "internationalMarketingPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "internationalMarketingEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Regularity Affair</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "regularityAffairName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: true,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "regularityAffairPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: true,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "regularityAffairEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: true,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Owner</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        key: "ownerName",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Name",
                          required: false,
                          type: "text",
                        },
                        validators: {
                          validation: ["normal-text"],
                        },
                      },
                      {
                        key: "ownerPhone",
                        type: "international-phone",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Phone",
                          required: false,
                          editing: false,
                        },
                        expressionProperties: {
                          "templateOptions.editing": () => {
                            return this.isEditMode;
                          },
                        }
                      },
                      {
                        key: "ownerEmail",
                        type: "input",
                        className: "col-md-6",
                        templateOptions: {
                          label: "Email",
                          required: false,
                          type: "email",
                        },
                        validators: {
                          validation: ["email"],
                        },
                      },
                    ],
                  },
                ],
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "productionInformation",
            fieldGroupClassName: "row",
            templateOptions: { title: "Production Information" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    key: "productDetailData",
                    type: "gmp-product-detail",
                    className: "col-md-12",
                    templateOptions: {
                      isDisabled: false,
                      editing: false,
                      isDataFilled: true
                    },
                    expressionProperties: {
                      "templateOptions.editing": () => {
                        return this.isEditMode;
                      },
                    }
                  },
                ],
              },
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "paymentInformation",
            templateOptions: { title: "Payment Information" },
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    type: 'lookup',
                    key: 'inspectionFee',
                    className: 'col-md-6',
                    templateOptions: {
                      label: "Payment Category",
                      required: true,
                      multiple: false,
                      prefetch: true,
                      searchable: false,
                      minLengthTerm: 0,
                      responseFn: (res) => res,
                      list: {
                        method: "get",
                        url: (term) => `${environment.baseUrl}/InspectionFee`,
                        responseFn: (res : Array<InspectionFee>) => {
                          return res.filter(m => m.isSra == false && m.hasMultipleFacility == false && m.code != "MTTP"
                            ).map(obj => ({ ...obj, name: obj.type }));
                        },
                      },
                    }
                  },
                  {
                    fieldGroupClassName: "col-md-12",
                    fieldGroup: [
                      {
                        template:
                          "<br><div><h2><strong>Control for good manufacturing practice (if the manufacturing companies having products in different town within one site in a country.)</strong></h2></div>",
                      },
                    ],
                  },
                  {
                    className: "col-md-7",
                    type: 'checkbox',
                    key: 'WHRF',
                    templateOptions: {
                        label: 'Warehouse for raw materials and finished products',
                    },
                  },
                  {
                    className: "col-md-7",
                    type: 'checkbox',
                    key: 'PFPQ',
                    templateOptions: {
                        label: 'For packaging of finished products, quality control and distribution license',
                    },
                  },
                  {
                    className: "col-md-7",
                    type: 'checkbox',
                    key: 'QCDL',
                    templateOptions: {
                        label: 'Quality control and distribution license',
                    },
                  },
                  {
                    key: "siteAddress",
                    type: "input",
                    className: "col-md-7",
                    templateOptions: {
                      label: "Site Address",
                      placeholder: 'Site Address',
                      required: true
                    },
                    hideExpression: (
                      model: any,
                      formState: any,
                      field: FormlyFieldConfig
                    ) => {
                      let WHRF = field.form.get("WHRF").value;
                      let PFPQ = field.form.get("PFPQ").value;
                      let QCDL = field.form.get("QCDL").value;
                      if (WHRF != null && PFPQ != null && QCDL != null) {
                        if (WHRF == true || PFPQ == true || QCDL == true) {
                          return false;
                        }
                        return true;
                      }
  
                      return true;
  
                    },
                  },
                  {
                    type: "input",
                    className: "col-md-7",
                    templateOptions: {
                      label: 'Total Fee',
                      placeholder: '0',
                      dependsOnField: "productionInformation.productDetailData",
                      disabled: true
                    },
                    expressionProperties: {
                      'templateOptions.placeholder': (model, formState, field: FormlyFieldConfig) => {
                        let appliedFees = [];
                        let totalFee = 0;
                        // for normal abroad => payment category + multiple facility + >2 production line fees 
                        if(model.inspectionFee){
                           appliedFees.push(this.inspectionFees.find(f => f.id == model.inspectionFee.id));                        
                        }
                        
                        let checkBoxKeys = (<any>Object).entries(model).map(m => m[0]).filter(key => ['WHRF', 'PFPQ', 'QCDL'].indexOf(key) != -1)
                        for (const key of checkBoxKeys) {
                          if(model[key] == true){
                            appliedFees.push(this.inspectionFees.find(f => f.code == key));
                          }
                        }

                        let nonProdLineFee = appliedFees.map(f => f.amount).reduce((prev, current) => prev + current, 0);  
                        
                        let prodDetails = field.form.parent?.value?.productionInformation?.productDetailData?.productDetails;
                        let extraProdLines = Math.max(0, this.inspectionService.countProductionLinesForFee(prodDetails) - 2);
                        if(extraProdLines > 0) {
                          const mttp = this.inspectionFees.find(f => f.code == 'MTTP');
                          appliedFees.push(mttp);
                          totalFee += mttp.amount * extraProdLines;
                        }

                        // multiple offsite facility payment
                        if(prodDetails && prodDetails.length > 0) {
                          const { uniqueOffsiteFacilitiesByNameAndAddressCount } = this.inspectionService.getOffsiteFacilitiesInfo(prodDetails)  

                          if(uniqueOffsiteFacilitiesByNameAndAddressCount > 0) {
                            appliedFees.push(this.inspectionFees.find(f => f.code == "MOF"));
                            totalFee += (uniqueOffsiteFacilitiesByNameAndAddressCount * this.inspectionFees.find(f => f.code == "MOF").amount);
                          }                    
                        }
  
                        totalFee += nonProdLineFee;
                        return totalFee + " (in USD)"; 
                      },
                    },
                  }, 
                  {
                    fieldGroupClassName: "col-md-7",
                    fieldGroup: [
                      {
                        template: "",
                       
                        expressionProperties: {
                          'template': () => {
                            let multipleProdLineFee = this.inspectionFees.find(f => f.code == 'MTTP');
                            let template = "";  
                            if(multipleProdLineFee){
                              template += `<span><span class='text-danger'>*</span>when more than two production lines are selected, 
                                each production line added costs ${multipleProdLineFee.amount} (in USD) </span>`
                            }
                            let multipleOffsiteFacilityFee = this.inspectionFees.find(f => f.code == 'MOF');
                            if(multipleOffsiteFacilityFee) {
                              template += `<br/> <span><span class='text-danger'>*</span>when offsite facilities are added, 
                                each offsite facility added costs ${multipleOffsiteFacilityFee.amount} (in USD) </span>`
                            }
                            
                            return template;
                          },
                        },
                      },
                    ],
                  },            
                ]
              }
            ],
            hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
              return this.isFIREditing;
            },
          },
          {
            key: "fileAttachment",
            templateOptions: {
              title: "File Attachment",
              icon: "fa fa-info-circle",
            },
            fieldGroup: [
              {
                key: "documents",
                type: "upload-list",
                templateOptions: {
                  label: "Applicant Name",
                  required: true,
                  items: [],
                  dependsOnField: "productionInformation.productDetailData",
                  dataSourceFn: (submoduleCode) => {
                    return {
                      url: `/DocumentRef/GMP/${submoduleCode}`,
                    };
                  },
                  extraData: {
                    urlParameter: "",
                    originalFileName: "-",
                    editing: false,
                    categoryTypeID: "",
                    AgencyTypeID: "",
                    ApplicantTypeID: "",
                  },
                  responseFn: (res) => res,
                },
                expressionProperties: {
                  "templateOptions.extraData.urlParameter": (
                    model,
                    formState,
                    field
                  ) => {
                    return this.currentInspectionType;
                  },
                  "templateOptions.extraData.editing": () => {
                    return this.isEditMode;
                  },
                  "templateOptions.extraData.categoryTypeID": () => {
                    return this.categoryId;
                  },
                  "templateOptions.extraData.AgencyTypeID": () => {
                    return this.agencyId;
                  },
                  "templateOptions.extraData.ApplicantTypeID": () => {
                    return this.applicantTypeId;
                  },
                },
              },
            ],
          },
        ],
      },
  ];

  valueChanged(field: FormlyFieldConfig) {}
}
